import { render, staticRenderFns } from "./AskAndAnswer.vue?vue&type=template&id=503626ea&scoped=true"
import script from "./AskAndAnswer.vue?vue&type=script&lang=js"
export * from "./AskAndAnswer.vue?vue&type=script&lang=js"
import style0 from "./AskAndAnswer.vue?vue&type=style&index=0&id=503626ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503626ea",
  null
  
)

export default component.exports